import { Row } from '../grid';
import { withInstall } from '../_util/type';
export default withInstall(Row);
